import {
  Divider,
  Paper,
  ToggleButton,
  ToggleButtonGroup,
  Typography
} from '@sanlam-glacier/app-common/components';
import styles from './investment-and-client-info.module.scss';
import { ClientToggleTabs } from 'modules/clients/types/client.enum';
import { useEffect, useState } from 'react';
import InvestmentInformationTabs from '../organisms/investment-information-tabs/InvestmentInformationTabs';
import clsx from 'clsx';

const views = [
  {
    id: ClientToggleTabs.investmentInformation,
    label: 'Investment information',
    content: <InvestmentInformationTabs />
  },
  {
    id: ClientToggleTabs.clientInformation,
    label: 'Client information',
    content: (
      <div>
        <p>Client Information View</p>
      </div>
    )
  }
];

const InvestmentAndClientInfo = () => {
  const [selectedView, setSelectedView] = useState<string>(ClientToggleTabs.investmentInformation);
  const [selectedToggleTab, setSelectedToggleTab] = useState<ClientToggleTabs>();

  const currentView = views.find((view) => view.id === selectedView);
  useEffect(() => {
    setSelectedToggleTab(ClientToggleTabs.investmentInformation);
  }, []);
  return (
    <div className={styles.investmentClientInfoContainer}>
      <Typography variant={Typography.VARIANT.H2} weight={Typography.WEIGHT.BOLD}>
        Investment & client information
      </Typography>

      <ToggleButtonGroup
        exclusive
        selected={[selectedView]}
        size={ToggleButtonGroup.SIZE.LARGE}
        className={styles.investmentClientInfoToggleTabs}
        onChange={(value) => {
          if (value) setSelectedView(value.toString());

          const toggleTabValue = Array.isArray(value) ? value.join(',') : value;

          Object.values(ClientToggleTabs).includes(toggleTabValue as ClientToggleTabs) &&
            setSelectedToggleTab(toggleTabValue as ClientToggleTabs);
        }}
      >
        {views.map((view) => (
          <ToggleButton
            key={view.id}
            aria-label={view.label}
            value={view.id}
            className={clsx(selectedToggleTab === view.id && styles.showAsSelectedToggleTab)}
          >
            {view.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>

      <Paper className={styles.tabContainer}>
        <Divider className={styles.tabUnderline} />
        {currentView?.content}
      </Paper>
    </div>
  );
};

export default InvestmentAndClientInfo;
